export interface PpAttendanceRecord {
  academySessionId?: number;
  memberNumber?: string;
  roomSlug: string;
  participantName: string;
  participantEmail?: string;
  joinedAtUtc?: string;
  leftAtUtc?: string;
  sessionStartsAtUtc?: string;
  sessionEndsAtUtc?: string;
}

export function csvCell(value: unknown): string {
  let text = String(value ?? '');
  if (/^\s*[=+@\-]/u.test(text)) text = "'" + text;
  return '"' + text.replace(/"/g, '""') + '"';
}

/** Administrative client snapshot; the authoritative webhook CSV is available in Academy. */
export function createPpAttendanceCsv(records: PpAttendanceRecord[], now = Date.now()): string {
  const grouped = new Map<string, { record: PpAttendanceRecord; intervals: [number, number][] }>();
  for (const r of records) {
    if (!r.academySessionId || !r.memberNumber || !r.joinedAtUtc) continue;
    const key = `${r.academySessionId}|${r.roomSlug}|${r.memberNumber}`;
    const group = grouped.get(key) || { record: r, intervals: [] };
    const a = Math.max(Date.parse(r.joinedAtUtc), Date.parse(r.sessionStartsAtUtc || r.joinedAtUtc));
    const b = Math.min(r.leftAtUtc ? Date.parse(r.leftAtUtc) : now, r.sessionEndsAtUtc ? Date.parse(r.sessionEndsAtUtc) : now, now);
    if (Number.isFinite(a) && Number.isFinite(b) && b > a) group.intervals.push([a, b]);
    grouped.set(key, group);
  }
  const rows: unknown[][] = [['session_id', 'room', 'member_number', 'participant_name', 'participant_email', 'duration_seconds', 'source']];
  for (const {record: r, intervals} of grouped.values()) {
    intervals.sort((a, b) => a[0] - b[0]);
    let end = 0, total = 0;
    for (const [a, b] of intervals) { total += Math.max(0, b - Math.max(end, a)); end = Math.max(end, b); }
    rows.push([r.academySessionId, r.roomSlug, r.memberNumber, r.participantName, r.participantEmail || '', Math.floor(total / 1000), 'vorbello_client']);
  }
  return '\uFEFF' + rows.map(r => r.map(csvCell).join(',')).join('\r\n');
}
